import { state, modes } from "../state.js";
import { BASIC } from "../BASIC.js";
import { printLine } from "../utilities.js";

/*
    The BASIC command NEW releases the whole BASIC RAM and the stack of the C64. Using the NEW command results in the BASIC program that was stored 
    in the memory being deleted. NEW can be used in programs, but after executing NEW, the program ends by being deleted. That is, using the BASIC 
    command NEW in programs does not usually make much sense. The command NEW should be used before writing a new BASIC program, because old program 
    code can conflict with the new BASIC code and complicate debugging. 
*/
export const newCommand = async () =>{
    state.loadedDirectory = null;
    state.loadedProgram = null;
    state.mode = modes.INPUT;
    BASIC.lines = [];
    
    await printLine();
};